import {
	BaseEntity,
	checkboxselectcolumn,
	column,
	Config,
	createComponent,
	DataSourceStore,
	datasourcestore,
	t,
	Table
} from "@intermesh/goui";
import {JmapDataSource, jmapds} from "@intermesh/groupoffice-core";
import {ACLLevelSubmitAsCustomer} from "./Index";

interface TaskList extends BaseEntity {
	name:string,
	group:any
}
export class TasklistTable extends Table<DataSourceStore<JmapDataSource<TaskList>>> {
	constructor() {

		const store = datasourcestore({
			dataSource: jmapds<TaskList>("SupportList"),
			relations: {
				group: {
					path: "groupingId",
					dataSource: jmapds("TaskListGrouping")
				}
			},
			queryParams: {
				limit: 0,
				filter: {
					permissionLevel: ACLLevelSubmitAsCustomer
				}
			},
			sort: [{property: "group", isAscending: true},{property: "name", isAscending: true}]
		});

		const columns = [
			checkboxselectcolumn({
				id: "selected",
			}),
			column({
				header: t("Name"),
				id:"name",
				resizable: true,
				width: 312,
				sortable: true
			})
		];
		
		super(store, columns );

		this.groupBy = "group";
		this.groupByRenderer = (groupBy) => groupBy ? `${groupBy.name.htmlEncode()}`: t("None");

		this.rowSelectionConfig =  {
			multiSelect: true
		};

	}
}

export const tasklisttable = (config?: Config<TasklistTable>) => createComponent(new TasklistTable(), config);